import { j as i } from "./jsx-runtime-944c88e2.js";
import * as t from "react";
import { p as l } from "./index-efd35e77.js";
import { a as d } from "./Enums-2eefd6e1.js";
import { v as m, c as n, p as s } from "./package-metadata-a152adb8.js";
import "./index-64063129.js";
var o = {
  sizeMap: {
    small: "sm",
    medium: "md",
    large: "lg"
  },
  roundedMap: {
    small: "sm",
    medium: "md",
    large: "lg"
  }
}, r = function(e) {
  var a;
  return m(s), t.createElement(
    "div",
    { style: e.style, className: n("k-avatar", (a = {}, a["k-avatar-bordered"] = e.border, a["k-rounded-".concat(o.roundedMap[e.rounded] || e.rounded)] = e.rounded, a["k-avatar-".concat(o.sizeMap[e.size] || e.size)] = e.size, a["k-avatar-".concat(e.fillMode)] = e.fillMode, a["k-avatar-".concat(e.fillMode, "-").concat(e.themeColor)] = !!(e.fillMode && e.themeColor), a), e.className) },
    t.createElement("span", { className: "k-avatar-".concat(e.type) }, e.children)
  );
};
r.propTypes = {
  className: l.string,
  type: l.oneOf(["text", "image", "icon"]),
  size: l.oneOf([null, "small", "medium", "large"]),
  rounded: l.oneOf([null, "small", "medium", "large", "full"]),
  fillMode: l.oneOf([null, "solid", "outline"]),
  /* eslint-disable max-len */
  themeColor: l.oneOf([null, "base", "dark", "error", "info", "inverse", "inverse", "light", "primary", "secondary", "success", "tertiary", "warning"])
};
r.defaultProps = {
  type: d.TEXT,
  size: "medium",
  rounded: "full",
  fillMode: "solid",
  themeColor: "primary"
};
const y = (e) => /* @__PURE__ */ i.jsx(r, { size: "large", rounded: "full", fillMode: "solid", themeColor: "primary", ...e, children: e.children });
export {
  y as Avatar
};
